import Icon from '@ant-design/icons';
import { Card, Flex, Image, Popconfirm, Typography } from 'antd';
import { Link } from 'react-router';
import { useTheme } from 'styled-components';
import { Template } from '../../types';
import { ActionButtonWrapper, StyledField } from './styles';
import { SVGDelete, SVGEdit } from '../../images';
import { useTranslation } from 'react-i18next';

type TemplateCardProps = {
  onClick?: (id: string) => void;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
  data: Template;
};

const Field = ({ label, value }: { label?: string; value?: string }) => (
  <StyledField gap={10}>
    <span className="label">{label}</span>
    <span>{value || '-'}</span>
  </StyledField>
);

const TemplateCard = (props: TemplateCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onClick, onDelete, onEdit, data } = props;

  const handleCardClick = () => {
    if (onClick) {
      onClick(data.templateID);
    }
  };

  return (
    <Card hoverable style={{ borderRadius: 0, cursor: 'default' }}>
      <Flex align="center" gap={24}>
        <Flex
          style={{
            backgroundColor: '#fff',
            height: 90,
            overflow: 'hidden',
            flexShrink: 0,
          }}
          align="center"
          justify="center"
        >
          <Link to={`${data.templateID}`}>
            <Image
              width={120}
              src={data?.images?.[0]?.url}
              preview={false}
              fallback="/placeholder.png"
              style={{ objectFit: 'contain', maxHeight: '100%' }}
            />
          </Link>
        </Flex>
        <Flex flex={1} vertical gap={16}>
          <Flex gap={20}>
            <Link to={`${data.templateID}`}>
              <Typography.Text style={{ color: theme.antd.colorPrimary }}>
                {data.name}
              </Typography.Text>
            </Link>
          </Flex>
          <Flex gap={24}>
            <Field label={t('type')} value={data.type} />
            <Field label={t('manufacturer')} value={data.manufacturer} />
          </Flex>
        </Flex>
        <Flex gap={8}>
          <ActionButtonWrapper
            onClick={(e) => {
              onEdit(data.templateID);
            }}
            style={{ cursor: 'pointer' }}
            title={t('edit')}
          >
            <Icon component={SVGEdit} />
          </ActionButtonWrapper>

          <Popconfirm
            placement="bottom"
            title={`Are you sure you want to delete ${data.name}`}
            okText="Yes"
            cancelText="No"
            onConfirm={(e) => onDelete(data.templateID)}
          >
            <ActionButtonWrapper
              style={{ cursor: 'pointer' }}
              title={t('delete')}
            >
              <Icon component={SVGDelete} />
            </ActionButtonWrapper>
          </Popconfirm>
        </Flex>
      </Flex>
    </Card>
  );
};

export default TemplateCard;
